import FleetStatistics from "@/models/FleetStatistics";

export default class FleetGrouped {

    constructor(id, name, vehicles = [], statistics = new FleetStatistics, isVisible = true) {
        this.id = id
        this.name = name
        this.vehicles = vehicles
        this.statistics = statistics
        this.isVisible = isVisible
    }

}
